import React, { FunctionComponent, MouseEventHandler, ReactNode, Ref, useMemo } from 'react';

import { TooltipStateful } from '@yandex-360/orb-components/dist/components/Tooltip';

import { Button } from '../../../../shared/components';
import SvgImage from '../../../../shared/components/svg-image';
import type { ImageName } from '../../../../shared/components/svg-image/images';
import css from './styles.css';

interface ModerationControlButtonProps {
    icon?: ReactNode;
    iconName?: ImageName;
    className?: string;
    iconClassName?: string;
    innerRef?: Ref<HTMLElement>;
    disabled?: boolean;
    title?: string;
    testId?: string;
    onClick?: MouseEventHandler;
}

const ModerationControlButton: FunctionComponent<ModerationControlButtonProps> = ({
    className,
    iconClassName,
    icon,
    iconName,
    disabled,
    onClick,
    title,
    testId,
    ...props
}) => {
    const buttonIcon = useMemo(() => {
        if (icon) {
            return <div className={iconClassName}>{icon}</div>;
        }
        if (iconName) {
            return <SvgImage className={iconClassName} imageName={iconName} />;
        }
    }, [icon, iconName, iconClassName]);

    return (
        <TooltipStateful content={title} trigger="hover">
            <div className={css.moderationControlButtonContainer}>
                <Button
                    className={className}
                    view="neutral-transparent"
                    size="xs"
                    icon={buttonIcon}
                    isDisabled={disabled}
                    onClick={onClick}
                    aria-label={title}
                    testId={testId}
                    {...props}
                />
            </div>
        </TooltipStateful>
    );
};

export default ModerationControlButton;
